import React, { createRef } from "react";
import PropTypes from "prop-types";
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import axios from 'axios/dist/axios.min.js'
import 'swiper/components/pagination/pagination.less'
import shihuo, { Exposure } from 'shihuo-lib/dist/shihuo-lib';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import utils from "../../utils/utils";
import "./style.less";
import RecommendSwiper from "./recommendSwiper";
import px2rem from "../../utils/px2rem";
let clientWidth = 375;
if (typeof window !== 'undefined') {
  clientWidth = window.document.body.clientWidth;
}
const screenRatio = (clientWidth) / 375;

// const bgList = [
//   {
//     bgUrl: 'https://static.shihuocdn.cn/admin/files/20220427/8ab09c6bfda95cae41dfb1ad162f7681.png',
//     imgBottomUrl: 'https://static.shihuocdn.cn/admin/files/20220427/02d5324a0d93028cbb8081b74932c491.png',
//   },
//   {
//     bgUrl: 'https://static.shihuocdn.cn/admin/files/20220427/0af1ff6261fa00da6f03402969b4c50d.png',
//     imgBottomUrl: 'https://static.shihuocdn.cn/admin/files/20220427/e5e7c38f2e4e2a9cf1240069c250d4a5.png',
//   },
//   {
//     bgUrl: 'https://static.shihuocdn.cn/admin/files/20220427/8d153d5162ea5ddcbc9dee304e62cdc9.png',
//     imgBottomUrl: 'https://static.shihuocdn.cn/admin/files/20220427/74149e87c1f54d8d6af6ae4865179ccb.png',
//   },
//   {
//     bgUrl: 'https://static.shihuocdn.cn/admin/files/20220427/fa98d29f09bd0f6f5c60258fdd7c971b.png',
//     imgBottomUrl: 'https://static.shihuocdn.cn/admin/files/20220427/7b5305ccc2cc1c9fd69ba7e247c06c2c.png',
//   }
// ];
const searchKeyHref = 'shihuo://www.shihuo.cn?route=goodsList&keywords='
class PipelineSenceSwiper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      goodsList: [],
    }
    this.tabActive = utils.getParams('tabActive')
    this.exp = new Exposure();
    this.swiperRef = createRef();
    this.goods_type = 3
    // this.goods_type = typeof window !== "undefined" && (window.squareStageType == '预售' ? 1 : (window.squareStageType == '预热' ? 2 : (window.squareStageType == '全部商品' ? 0 : 3)))
    this.pageId = typeof window !== "undefined" && window.location.host === "zt-public.shihuo.cn"
      ? window.location.href.indexOf('zt-public.shihuo.cn/stage') > -1
        ? window.location.pathname.split("/")[3]
        : window.location.pathname.split("/")[2]
      : 0;
  }

  async componentDidMount() {
    this.gender = await this.getMenuBarConfigSex();
    this.getMainPushGoodsList();
  }
  getMenuBarConfigSex() {
    const { allComponents = [] } = this.props;
    let menuData = null;
    allComponents && allComponents.map(item => {
      if (item.name == 'pipeline-menuBar') {
        menuData = item.data && item.data.containerConfig && item.data.containerConfig.grains
      }
    })
    let title = '';
    if (menuData && menuData.length > this.tabActive) {
      title = menuData[this.tabActive] && menuData[this.tabActive].menuName
    }
    if (title) return title.indexOf('男') > -1 ? 'male' : title.indexOf('女') > -1 ? 'female' : 'common'
    return 'common'
  }
  initSwiper() {
    // 轮播组件初始化
    this.initListener && clearTimeout(this.initListener);
    this.initListener = null;
    this.initListener = setTimeout(() => {
      this.swiper = new Swiper(this.swiperRef.current, {
        // slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: true,
        // pagination: {
        //   el: this.swiperPaginationRef.current,
        //   type: 'progressbar',
        //   clickable: true,
        // },
        autoplay: false,
        loop: false
      });
      this.swiper.on('slideChange', () => {
        this.handleSlideChange(this.swiper)
      });
      this.handleSlideChange({ realIndex: 0 });
    }, 1000)

  }
  // 获取楼层主推商品列表
  getMainPushGoodsList = () => {
    let requestIndex = 0;  // 楼层数据请求的数量
    const { categoryList } = this.props.config;
    let titleCategoryIdList = [];
    let newCategoryList = [];
    categoryList && categoryList.map((item, index) => {
      if (item.titleCategoryId) {
        titleCategoryIdList.push({ key: String(index), cate: item.titleCategoryId })
      } else {
        newCategoryList.push(item)
      }
    })
    if (titleCategoryIdList && titleCategoryIdList.length > 0) {
      axios({
        baseURL: 'https://sh-gateway.shihuo.cn',
        url: '/v4/services/sh-venueapi/common/tabOrder?access_token=znSnA7pxO35wtPBaur',
        method: 'post',
        withCredentials: true,
        data: {
          cateList: titleCategoryIdList,
          scene: 'ACTIVITY_11_TAB_REC',
          from: window.location.href
        },
      }).then(res => {
        res = res.data
        if (res.status == 0) {
          const { orderCateList = [] } = res.data || {}
          orderCateList.forEach(key => {
            categoryList.forEach((item, index) => {
              if (key == index) {
                newCategoryList.push(item)
              }
            })
          })
          console.log('newCategoryList', newCategoryList);
          this.getListData(newCategoryList)
        }
      })
    } else {
      this.getListData(newCategoryList)
    }
  }

  getListData(categoryList = []) {
    categoryList.length > 0 && categoryList.forEach((senceTabItem, senceTabIndex) => {
      const { mainPush } = senceTabItem
      const moduleElement = {
        index: senceTabIndex,
        tabCurIndex: 0,
        configType: mainPush.configType,
        mainPushList: [],
        ...senceTabItem
      }
      if (mainPush.configType === "商品id(维度)" || mainPush.configType === "配色id(维度)") {
        const pref = mainPush.configType === "商品id(维度)" ? 'g' : 'p'
        const itemList = ((pref == 'g' && mainPush.layout_goodsId.id) || mainPush.layout_styleId.id || '').split(",");
        const idList = itemList.map((item) => {
          return isNaN(Number(item)) ? 0 : pref + item;
        });

        axios({
          baseURL: 'https://sh-gateway.shihuo.cn',
          url: '/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',
          method: "post",
          withCredentials: true,
          data: {
            goods_id: idList,
            goods_type: this.goods_type
          },
        }).then((res) => {
          if (res.data.status === 0) {
            const list = res.data.data.goods_list || [];
            // 插入定制化内容
            list.forEach((product, indexNum) => {
              let customItem = null;
              if (mainPush.configType === "商品id") {
                customItem = itemList.find && itemList.find((item) => item.id == product.goodsId);
              } else {
                customItem = itemList.find && itemList.find((item) => item.id == product.styleId);
              }
              if (customItem) {
                product.custom_image = customItem.image;
                product.custom_title = customItem.title;
                product.custom_subTitle = customItem.subTitle;
              }
            });
            Object.assign(moduleElement, {
              mainPushList: list.length > 4 ? this.getRandomMainPush(list, 4) : list
            })
            if (moduleElement.searchKeyList && moduleElement.searchKeyList.length > 0) {
              moduleElement.searchKeyList = this.handleSearchKeySort(moduleElement.searchKeyList);
            }
            let goodsList = this.state.goodsList;
            goodsList.push(moduleElement);
            goodsList = this.handleFloorSort(goodsList);
            // goodsList && goodsList.map(item => {
            //   const currentBg = bgList[Math.round(Math.random() * 3)] || {}
            //   item.currentBg = currentBg

            // })
            this.setState({
              goodsList
            }, () => {
              this.initSwiper();
            })
          }
        });
      } else if (mainPush.configType === "二级类目id(维度)") {
        const itemList = (mainPush.layout_categoryId.id || mainPush.layout_categoryId.id).split(",");
        const idList = itemList.map((item, index) => {
          return isNaN(Number(item)) ? 0 : item;
        });
        axios({
          baseURL: 'https://sh-gateway.shihuo.cn',
          url: '/v4/services/sh-venueapi/common/goodsListByCate?access_token=znSnA7pxO35wtPBaur',
          method: 'post',
          withCredentials: true,
          data: {
            cate: idList,
            page_size: 66,
            page_on: 1,
            goods_type: this.goods_type,
            from: window.location.href,
            scene: 'ACTIVITY_11_GOODSLIST_REC',
            goods_from: 0,
            gender: this.gender
          },
        }).then((res) => {
          if (res.data.status === 0) {
            const list = res.data.data.goods_list || [];
            // 插入定制化内容
            list.forEach((product, indexNum) => {
              let customItem = null;
              if (mainPush.configType === "商品id") {
                customItem = itemList.find && itemList.find((item) => item.id == product.goodsId);
              } else {
                customItem = itemList.find && itemList.find((item) => item.id == product.styleId);
              }
              if (customItem) {
                product.custom_image = customItem.image;
                product.custom_title = customItem.title;
                product.custom_subTitle = customItem.subTitle;
              }
            });
            Object.assign(moduleElement, {
              mainPushList: list.length > 4 ? this.getRandomMainPush(list, 4) : list
            })
            if (moduleElement.searchKeyList && moduleElement.searchKeyList.length > 0) {
              moduleElement.searchKeyList = this.handleSearchKeySort(moduleElement.searchKeyList);
            }
            let goodsList = this.state.goodsList;
            goodsList.push(moduleElement);
            // goodsList = this.handleFloorSort(goodsList);
            // goodsList && goodsList.map(item => {
            //   const currentBg = bgList[Math.round(Math.random() * 3)] || {}
            //   item.currentBg = currentBg
            // })
            console.log('goodsList', goodsList);
            this.setState({
              goodsList
            }, () => {
              this.initSwiper();
            })
          }
        });
      }
      // const pref = mainPush.configType === "商品id" ? 'g' : 'p'
      // const itemList = mainPush.mainPushProductList;
      // const idList = itemList.map((item) => {
      //   return isNaN(Number(item.id)) ? 0 : pref + item.id;
      // });

      // axios({
      //   baseURL: 'https://sh-gateway.shihuo.cn',
      //   url: '/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',
      //   method: "post",
      //   withCredentials: true,
      //   data: {
      //     goods_id: idList,
      //     goods_type: this.goods_type
      //   },
      // }).then((res) => {
      //   if (res.data.status === 0) {
      //     const list = res.data.data.goods_list || [];
      //     // 插入定制化内容
      //     list.forEach((product, indexNum) => {
      //       let customItem = null;
      //       if (mainPush.configType === "商品id") {
      //         customItem = itemList.find && itemList.find((item) => item.id == product.goodsId);
      //       } else {
      //         customItem = itemList.find && itemList.find((item) => item.id == product.styleId);
      //       }
      //       if (customItem) {
      //         product.custom_image = customItem.image;
      //         product.custom_title = customItem.title;
      //         product.custom_subTitle = customItem.subTitle;
      //       }
      //     });
      //     Object.assign(moduleElement, {
      //       mainPushList: list.length > 4 ? this.getRandomMainPush(list, 4) : list
      //     })
      //     let goodsList = this.state.goodsList;
      //     goodsList.push(moduleElement);
      //     goodsList = this.handleFloorSort(goodsList);
      //     goodsList && goodsList.map(item => {
      //       const currentBg = bgList[Math.round(Math.random() * 3)] || {}
      //       item.currentBg = currentBg
      //     })
      //     this.setState({
      //       goodsList
      //     }, () => {
      //       requestIndex++;
      //       if (requestIndex == categoryList.length) {
      //         this.initSwiper();
      //       }
      //     })
      //   }
      // });
    });
  }

  // 搜索词随机排序
  handleSearchKeySort = (arr) => {
    return arr.sort(() => Math.random() - 0.5);
  }
  // 楼层主推商品随机展示
  getRandomMainPush = (arr, n) => {
    const result = [];
    for (let i = 0; i < n; i++) {
      var random = Math.floor(Math.random() * arr.length);
      if (result.includes && result.includes(arr[random])) {
        continue;
      }
      result.push(arr[random]);
      arr.splice(random, 1);
    }
    return result;
  }
  // Tab楼层随机排序
  handleFloorSort = (arr) => {
    const pageIds = this.getCookie('pageIds');
    if (pageIds && pageIds.indexOf(this.pageId) >= 0) {
      // 非首次进入，随机排序展示
      return arr.sort(() => Math.random() - 0.5);
    } else {
      // 首次进入，按顺序展示
      return arr.sort((a, b) => {
        return a.index - b.index
      });;
    }
  }
  // 获取Cookie
  getCookie = (name) => {
    var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if ((arr = document.cookie.match(reg))) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  }

  handleSlideChange = (swiper) => {
    const activeIndex = swiper.realIndex;
    const that = this;
    this.setState({
      activeIndex,
    }, () => {
      let targetTabContainer, view;
      if (this.props.tabActive) {
        targetTabContainer = window.document.querySelectorAll('.tab-container')[this.props.tabActive];
        view = targetTabContainer && targetTabContainer.querySelector(".bottom-img-ul");
      } else {
        view = document.getElementById('bottom-img-container');
      }
      that.scroll(view.scrollLeft, (activeIndex - 1) * 120 / 2)
    });
  }

  scroll(currentY, targetY) {
    // 计算需要移动的距离
    let needScrollTop = targetY - currentY
    let _currentY = currentY
    setTimeout(() => {
      // 一次调用滑动帧数，每次调用会不一样
      const dist = Math.ceil(needScrollTop / 10)
      _currentY += dist
      let targetTabContainer = null;
      if (this.props.tabActive) {
        targetTabContainer = window.document.querySelectorAll('.tab-container')[this.props.tabActive];
        targetTabContainer && targetTabContainer.querySelector(".bottom-img-ul").scrollTo(_currentY, 0);
      } else {
        document.getElementById('bottom-img-container').scrollTo(_currentY, 0)
      }
      // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
      if (needScrollTop > 10 || needScrollTop < -10) {
        this.scroll(_currentY, targetY)
      } else {
        if (this.props.tabActive) {
          targetTabContainer && targetTabContainer.querySelector(".bottom-img-ul").scrollTo(_currentY, 0);
        } else {
          document.getElementById('bottom-img-container').scrollTo(_currentY, 0)
        }
      }
    }, 1)
  }
  slideClick = (clickIndex) => {
    this.setState({
      activeIndex: clickIndex,
    });
  }
  // 场景Tab点击
  handleTabItemClick(ptiId, categoryName, index) {
    // shihuo.uploadTrack({
    //   page_id: this.pageId,
    //   pti: {
    //     id: ptiId,
    //     pageId: this.pageId,
    //     page_id: this.pageId,
    //     name: categoryName
    //   }
    // });
    const newProps = JSON.parse(JSON.stringify(this.props));
    Object.assign(newProps, {
      tabChName: categoryName,
      floor_name: categoryName
    });
    utils.uploadTrack(newProps, {
      sort: index,
    }, { bizExtra: { model_block: 'tab', floor_name: categoryName } });
    this.setState({
      curTabIndex: index,
    }, () => {
      // console.log('this.swiperRef', this.swiper);
      this.swiper && this.swiper.slideTo(index, 300, false)
      // console.log('this.swiperRef', this.swiper && this.swiper.slideTo(index, 500, false));
    });
  }
  transformPx = (num) => {
    // 对单位进行转换
    num = Number(num);
    if (isNaN(num)) {
      num = 0;
    }
    const realNum = Math.round(num * screenRatio);
    return realNum;
  }
  render() {
    const { baseConfig, tabFontColor, tabSelectedFontColor } = this.props.config;
    const { goodsList = [] } = this.state;
    const activeIndex = this.state.activeIndex;
    if (!goodsList || goodsList.length < activeIndex) {
      return null;
    }
    return (
      <div
        className="pipeline-sence-swiper"
        {...this.props['customAttributes']}
        style={{
          marginTop: `${baseConfig.moduleMarginTop}px`,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`
        }}
      >
        <div className="swiper-container-parent">
          <div className="swiper-container" ref={this.swiperRef}>
            <div className="swiper-wrapper" >
              {goodsList.map((floorItem, floorIndex) => {
                const { title, titleFontColor, searchKeyList = [], searchKeyBgColor, searchKeyFontColor, categoryRecommend, mainPushList = [], categoryCard } = floorItem;
                // const { bgUrl } = currentBg;
                let { categoryCardBgImage, categoryCardRecommendIcon, floorBgColor, floorBgImage } = floorItem;
                categoryCardBgImage = categoryCardBgImage || 'https://static.shihuocdn.cn/admin/files/20220427/02d5324a0d93028cbb8081b74932c491.png';
                floorBgImage = (!floorBgImage && !floorBgColor) ? 'https://static.shihuocdn.cn/admin/files/20220427/8ab09c6bfda95cae41dfb1ad162f7681.png' : floorBgImage
                // console.log(floorItem, 'floorBgColor, floorBgImage', floorBgColor, floorBgImage);
                return <div className="swiper-slide" key={floorIndex}
                >
                  {floorBgImage ? <LazyLoadImage
                    width="100%"
                    threshold={10}
                    height={this.transformPx(384)}
                    src={utils.formatImgUrl(floorBgImage, this.props.webpSupport)}
                    effect="opacity"
                    style={{ zIndex: -1, position: 'absolute', top: 0, left: 0,right: 0 }}
                  /> : floorBgColor ? <div style={{ width: '100%', height: this.transformPx(384), zIndex: -1, position: 'absolute', top: 0, left: 0, right: 0, backgroundColor: floorBgColor, overflow: 'hidden', borderRadius: '12px' }} /> : null}
                  <div className="product-detail" onClick={this.slideClick.bind(this, floorIndex)}>
                    <div className="main-push-pro">
                      <div className="main-top">
                        <div className="main-top-left">
                          <h3 className="main-top-title" style={{ color: titleFontColor || '#FFFFFF' }}>{title}</h3>
                          <div className="main-top-desc">
                            {
                              searchKeyList && searchKeyList.map((mainPushProduct, mainPushIndex) => {
                                if (!mainPushProduct.title) {
                                  return null;
                                }
                                return <div key={mainPushIndex} className="main-top-desc-item" style={{ backgroundColor: searchKeyBgColor || '#00000040', color: searchKeyFontColor || '#FFFFFF' }} onClick={() => {
                                  const detailHref = `${searchKeyHref}${encodeURIComponent(mainPushProduct.title)}`
                                  const options = {
                                    sort: mainPushIndex,
                                    tabChName: mainPushProduct.title,
                                    floor_name: title
                                  }
                                  utils.jumpToUrl(this.props.routeParams, detailHref, detailHref, options, -1, { ...this.props, ...options }, false, { bizExtra: { model_block: 'keywords', floor_name: title }, categoryName: title });
                                }}>
                                  <span style={{ textAlign: 'center', lineHeight: '20px',marginBottom: utils.isAndroid() ? '-2px': '0px' }}>{mainPushProduct.title}</span>
                                </div>
                              })
                            }
                          </div>
                          {(categoryCard || categoryRecommend) && <RecommendSwiper categoryName={title} routeParams={this.props.routeParams} categoryCardBgImage={categoryCardBgImage} categoryCardRecommendIcon={categoryCardRecommendIcon} categoryRecommend={categoryRecommend} categoryCard={categoryCard} floorIndex={floorIndex} {...this.props} />}
                        </div>
                        <div className="main-top-right">
                          <ul className="main-top-list">
                            {mainPushList && mainPushList.slice(0, 4).map((categoryProItem, categoryProIndex) => {
                              if (categoryProIndex > 3) return;
                              const ptiId = `lego-valentineDay:sence-swiper-tab_${floorIndex}-goods:${categoryProIndex}`
                              const goods_id = categoryProItem.goodsId || categoryProItem.id;
                              const style_id = categoryProItem.styleId || categoryProItem.id;
                              return (
                                <li
                                  className="main-top-li"
                                  key={categoryProIndex}
                                  onClick={() => {
                                    const detailHref = categoryProItem.detailHref || categoryProItem.link;
                                    const options = {
                                      sort: categoryProIndex,
                                      tabChName: categoryProItem.goodsName || categoryProItem.title,
                                      floor_name: title
                                    }
                                    utils.jumpToUrl(this.props.routeParams, detailHref, detailHref, options, -1, { ...this.props, ...options }, false, { bizExtra: { model_block: 'goods', floor_name: title }, categoryName: title, goods_id, style_id });
                                  }}
                                  data-dot={JSON.stringify({
                                    id: ptiId,
                                    name: '',
                                    href: '',
                                    biz: JSON.stringify({
                                      ptiId,
                                      page_id: this.pageId,
                                      pageId: this.pageId,
                                      categoryName: title,
                                      goods_id,
                                      style_id
                                    }),
                                    exposekey: `categoryProIndex_${categoryProIndex}`,
                                    pti_refer: {
                                      pageId: '',
                                      root: {
                                        id: '',
                                        pageId: '',
                                        name: '',
                                        biz: '',
                                      },
                                      parent: {
                                        id: '',
                                        pageId: '',
                                        name: '',
                                        biz: '',
                                      },
                                    },
                                  })}
                                  ref={ele => {
                                    if (ele) {
                                      this.exp.add({ el: ele });
                                    }
                                  }}
                                >
                                  <div className="pro-item-parent">
                                    <div className="pro-item-img-two">
                                      <LazyLoadImage
                                        width="100%"
                                        threshold={500}
                                        height="100%"
                                        src={utils.formatImgUrl(categoryProItem.pic || categoryProItem.image, this.props.webpSupport)}
                                        effect="opacity"
                                      />
                                    </div>
                                    {/* <img className="pro-item-img-two" src={categoryProItem.image || categoryProItem.custom_image} /> */}
                                    <div className="pro-item-two">
                                      <p className="title">{categoryProItem.goodsName || categoryProItem.title}</p>
                                      <p className="price">¥{categoryProItem.price}</p>
                                    </div>
                                    {categoryProItem.tag && <div className="pro-item-two-tag" style={{
                                      background: `url(https://static.shihuocdn.cn/admin/imgs/20230117/e5b10a1108cc5cddf0f62b49c6b8c245_137x41.png) no-repeat`,
                                      backgroundSize: "100% 100%"
                                    }}>
                                      <p className="title">{categoryProItem.tag}</p>
                                    </div>}
                                  </div>
                                </li>
                              )
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              })}
            </div>
          </div>
          <div className="bottom-img-container" >
            <ul className="bottom-img-ul" id={"bottom-img-container" + (this.props.tabActive || '')}>
              {goodsList.map((item, index) => {
                const isSelected = activeIndex == index;
                const ptiId = `lego-valentineDay:sence-swiper-tab:${activeIndex + 1}`
                return <li key={index}
                  className="bottom-img-li-parent"
                  style={{
                    marginLeft: index == 0 ? '9px' : '0px',
                    marginRight: index == goodsList.length - 1 ? '15px': '8px',
                    marginBottom: isSelected ? 0: '6px'
                  }}
                  onClick={() => {
                    this.handleTabItemClick(ptiId, item.title, index)
                  }} >
                  <div
                    className={isSelected ? "bottom-img-li-float": 'bottom-img-li'}
                    style={{
                      marginLeft: '5px'
                    }}>
                    <LazyLoadImage
                      width="100%"
                      threshold={500}
                      height="100%"
                      src={utils.formatImgUrl(isSelected ? item.floorIconImage : item.floorUnSelectedIconImage, this.props.webpSupport)}
                      effect="opacity"
                    />
                  </div>
                  {item.floorIconTitle && <div className={isSelected ? 'bottom-btn-li-selected' : 'bottom-btn-li'} style={{
                    bottom: !utils.isAndroid() ? (isSelected ? '2px': '-10px') : (isSelected ? '0px': '1px')
                  }}>
                    <div className="bottom-btn-li-title" style={{ color: isSelected ? (tabSelectedFontColor || '#FFFFFF') : (tabFontColor || '#FF8D8D') }}>
                      {item.floorIconTitle}
                    </div>
                  </div>}
                </li>
              })}
              <div style={{width: '1px'}}/>
            </ul>
          </div>
          {goodsList.length > 0 && <div className="bottom-swiper-pagination-parent">
            <div className="bottom-swiper-pagination" style={{ width: goodsList.length * 10 }}>
              <div className="bottom-swiper-pagination-fill" style={{ marginLeft: activeIndex * 10 }} />
            </div>
          </div>}
        </div>

      </div>
    );
  }
}

PipelineSenceSwiper.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSenceSwiper };
export default PipelineSenceSwiper;



// WEBPACK FOOTER //
// ./components/pipeline-sence-swiper/index.js